import {Api} from '../../../Api.js'

const RESOURCE = 'tag'

export default {
    resource: RESOURCE,
    all(query) {
        return Api().get(this.resource + '/all' + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    add(data) {
        return Api().post(this.resource + '/add', data)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    import(data) {
        return Api().post(this.resource + '/import', data)
    },
}


// WEBPACK FOOTER //
// ./src/modules/config/tag/TagService.js